import List from './list.vue';
import Full from '@rebuild/materials/shared/us_announcement/Full.vue';

export const componentMap = {
	list: List,
	full: Full
};
